import * as d3 from "d3";
import {
  ControllerGlobals,
  genericXHRErrorHandler,
  startLoading,
  stopLoading,
  toastError,
  toastErrorSingle,
  toastInfo,
  toastInfoSingle,
  toastRemoveAll
} from "src/components/Planner/controller";
import { getDeviceById, getNote, getNoteById, uDev } from "src/components/Planner/planner/uDev";
import {
  deleteDevNote,
  deleteSoleNote,
  modDevNote,
  modSoleNote,
  sendDevNote,
  sendSoleNote,
  uDevDOM
} from "src/components/Planner/planner/uDev-dom";
import $ from "jquery";
import {
  CreateDevNoteAction,
  DeleteDevNoteAction,
  DeleteSoleNoteAction,
  DragSoleNoteAction,
  ModifyNoteAction
} from "src/components/Planner/planner/history/note-actions";
import {ts} from "src/utils/translate";
import {uMath} from "src/components/Planner/planner/uMath";
import {redrawDevices} from "src/components/Planner/planner/deviceDrawing";
import {
  disablePlannerButtonsExcept,
  enablePlannerButtons,
  getXYP,
  hideRotateAndDeviceTools,
  hideTools,
  setMouseDownXY,
  setPageXY,
  toolbarSwitchSet,
  unHighlight,
  updateDragXY
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import {
  createToolTooltip,
  drawToolBackground,
  getToolSize
} from "src/components/Planner/planner/deviceTools";
import {
  showDragAndDropOverlay
} from "src/components/Planner/planner/draganddrop";
import { getFrontendURL } from "src/utils/url";

let _noteCallbacks = {
  onNoteEdit: null,
  onNoteEditOnDevice: null,
  onNoteAddToDevice: null,
};

export function setNoteCallbacks({ onNoteEdit, onNoteEditOnDevice, onNoteAddToDevice }) {
  _noteCallbacks.onNoteEdit = onNoteEdit;
  _noteCallbacks.onNoteEditOnDevice = onNoteEditOnDevice;
  _noteCallbacks.onNoteAddToDevice = onNoteAddToDevice;
}

// TODO: moveplannercode-deadcode — only used by the dead jQuery note-modal flow, superseded by React AddNoteDialog (#352)
export function rgb2hex(rgb) {
  if (/^#[0-9A-F]{6}$/i.test(rgb)) {
    return rgb;
  }

  rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

  function hex(x) {
    return ("0" + parseInt(x).toString(16)).slice(-2);
  }

  return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
}

// TODO: moveplannercode-deadcode — only used by the dead jQuery note-modal flow, superseded by React AddNoteDialog (#352)
export function LightenDarkenColorHEX(col, amt) {

  var usePound = false;

  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) {
    r = 255;
  } else if (r < 0) {
    r = 0;
  }

  var b = ((num >> 8) & 0x00FF) + amt;

  if (b > 255) {
    b = 255;
  } else if (b < 0) {
    b = 0;
  }

  var g = (num & 0x0000FF) + amt;

  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);

}

// TODO: moveplannercode-deadcode — jQuery note-modal flow, superseded by React AddNoteDialog (#352)
export function setNoteModalCurrColor() {
  var selected = $('#addmod-note-modal').find('.selectable-color.selected');
  var sColor = rgb2hex(selected.css('background-color'));
  var lighterColor = LightenDarkenColorHEX(sColor, 40);
  var darkerColor = LightenDarkenColorHEX(sColor, -40);
  var buttonDarkColor = LightenDarkenColorHEX(sColor, -30);
  $('#addmod-note-modal').find('.modal-content').css('background-color',
      lighterColor);
  $('#addmod-note-modal').find(
      '.modal-header, .modal-footer, .modal-content').css('border-color',
      darkerColor);
  $('#addmod-note-modal').find('.confirm-btn').css('background',
      buttonDarkColor);
}

// TODO: moveplannercode-deadcode — jQuery note-modal flow, superseded by React AddNoteDialog (#352)
export function openNoteModal(action, params) {
  resetAddModNoteModal();
  showDragAndDropOverlay(false);
  if (action === "mod") {
    var txt, color;
    if (params.type === "device") {
      var dev = getDeviceById(params.id);
      if (dev && dev.noteTxt && dev.noteColor) {
        txt = dev.noteTxt;
        color = dev.noteColor;
      } else {
        return;
      }
    } else if (params.type === "sole") {
      var note = getNoteById(params.id);
      if (note) {
        txt = note.text;
        color = note.color;
      } else {
        return;
      }
    }
    $('#addmod-note-modal').find('textarea').val(txt);
    var colorcont = $('#addmod-note-modal').find('.color-container');
    colorcont.find('.selectable-color').removeClass('selected');
    var colorElem = colorcont.find(
        '.selectable-color[style="background-color: ' + color + ';"]');
    if (colorElem.length) {
      colorElem.addClass('selected');
    } else {
      colorcont.find('.selectable-color').first().addClass('selected');
    }
    setNoteModalCurrColor();
    $('#addmod-note-modal').find('.add-text').hide();
    $('#addmod-note-modal').find('.mod-text').show();
  } else if (action === "add") {
    $('#addmod-note-modal').find('.mod-text').hide();
    $('#addmod-note-modal').find('.add-text').show();
  }

  $('#addmod-note-modal').modal({
    backdrop: false,
    keyboard: true,
    show: true
  });
  $('#addmod-note-modal').data('params', params);
}

// TODO: moveplannercode-deadcode — jQuery note-modal flow, superseded by React AddNoteDialog (#352)
export function resetAddModNoteModal() {
  var colorcont = $('#addmod-note-modal').find('.color-container');
  colorcont.find('.selectable-color').removeClass('selected');
  colorcont.find('.selectable-color').first().addClass('selected');
  setNoteModalCurrColor();
  $('#addmod-note-modal').find('textarea').val('');
}

// TODO: moveplannercode-deadcode — jQuery note-modal flow, superseded by React AddNoteDialog (#352)
export function noteModalConfirmHandler() {
  var text = $('#addmod-note-modal').find('textarea').val().trim();
  var splittedIsEmpty = text.split("_").every(function (str) {
    return str.trim().length === 0;
  });
  if (text.length === 0 || splittedIsEmpty) {
    $('#addmod-note-modal').find('textarea')[0].select();
    toastInfoSingle(ts("p_note_new_empty", "Please enter a note."));
  } else {
    var params = $('#addmod-note-modal').data('params');
    var color = rgb2hex(
        $('#addmod-note-modal').find('.selectable-color.selected').css(
            'background-color'));
    if (params.type === "device") {
      /* console.log('setting note', text, 'to deviceId', params.id); */
      var dev = getDeviceById(params.id);
      if (dev) {
        var strId = dev.deviceId + "";
        var type = strId.indexOf('C_') === 0 ? 3 : 2;

        startLoading();
        if (dev.hasNote) {
          modDevNote(dev, color, text, function (dev) {
            if (dev && typeof params.callback === "function") {
              params.callback(dev.noteTxt, dev.noteColor);
            }
          });
        } else {
          sendDevNote(type, color, text, strId, dev, function (dev) {
            if (dev && typeof params.callback === "function") {
              params.callback(dev.noteTxt, dev.noteColor);
            }
          });
        }
      }
    } else if (params.type === "sole" && typeof params.callback
        === "function") {
      params.callback(text, color);
      closeAddModNoteModal();
    }
  }
}

// TODO: moveplannercode-deadcode — jQuery note-modal flow, superseded by React AddNoteDialog (#352)
export function noteModalDelHandler() {
  var params = $('#addmod-note-modal').data('params');
  deleteNote(params.id, params.type);
}

export function deleteNote(id, type) {
  if (type === "dev") {
    var dev = getDeviceById(id);
    if (dev) {
      var oriId = dev.noteId;
      var oriTxt = dev.noteTxt;
      var oriClr = dev.noteColor;
      deleteDevNote(dev, function () {
        redrawDevices();
        closeAddModNoteModal();
        var action = new DeleteDevNoteAction(dev.deviceId, oriId, oriTxt,
            oriClr);
        PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
      });
    }
  } else if (type === "sole") {
    var note = getNoteById(id);
    if (note) {
      deleteSoleNote(id, function () {
        redrawNotes();
        closeAddModNoteModal();
        var action = new DeleteSoleNoteAction(note.note_id, note.x, note.y,
            note.text, note.color);
        PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
      });
    }
  }
}

// TODO: moveplannercode-deadcode — only used by the dead noteModalToClipboard, superseded by React AddNoteDialog (#352)
export function getNoteModalColorAsHex() {
  return rgb2hex($('#addmod-note-modal').find('.selectable-color.selected').css(
      'background-color'));
}

// TODO: moveplannercode-deadcode — no callers, jQuery note-modal flow superseded by React AddNoteDialog (#352)
export function noteModalToClipboard() {
  var text = $('#addmod-note-modal').find('textarea').val().trim();
  var splittedIsEmpty = text.split("_").every(function (str) {
    return str.trim().length === 0;
  });
  if (text.length === 0 || splittedIsEmpty) {
    $('#addmod-note-modal').find('textarea')[0].select();
    toastInfoSingle(ts("p_note_new_empty", "Please enter a note."));
  } else {
    var clr = getNoteModalColorAsHex();
    PlannerGlobals.clipboard = {type: 'note', color: clr, text: text};
    toastInfo(ts('p_note_copied', 'Note copied'));
    closeAddModNoteModal();
  }
}

export function closeAddModNoteModal() {
  $('#addmod-note-modal').modal('hide');
  showDragAndDropOverlay();
}

// TODO: moveplannercode-deadcode — only reached via the dead "new_note" branch in deviceDrawing.placeDevice; sole-note add now dispatches onNoteDrop → React AddNoteDialog (#352)
export function showAddSoleNoteModal(x, y, callback) {
  openNoteModal("add", {
    type: "sole", callback: function (text, color) {
      sendSoleNote(x, y, text, color, callback);
    }
  });
}

/**
 *
 * @param {number} id
 * @param {"sole" | "dev"} type
 * @returns
 */
export function showNoteTools(id, type) {
  if (PlannerGlobals.isDragging || PlannerGlobals.mode == "rotateMe") {
    return;
  }
  if (PlannerGlobals.noteClipBtnTimeout) {
    clearTimeout(PlannerGlobals.noteClipBtnTimeout);
  }
  var note = getNote(id, type);
  var rect = getNoteRect(id, type);
  if (!note || note.ghost || note.nopermission
      || !rect.length /* || note.readOnly */) {
    return;
  }

  // ez a feltétel átmozgatja a device-ot más sorrendbe hogy ne fedje a popápot egy másik eszköz
  const deviceElement = d3.select('[data-serDevId="' + id + '"]');
  if (deviceElement.node()) {
    deviceElement.node().parentNode.appendChild(deviceElement.node());
  } else {
    const deviceIdElement = d3.select('[data-deviceId="' + id + '"]');
    if (deviceIdElement.node()) {
      deviceIdElement.node().parentNode.parentNode.appendChild(
          deviceIdElement.node().parentNode);
    }
  }

  var rectNode = rect[0];
  var rectd3 = d3.select(rectNode);

  hideTools();
  hideRotateAndDeviceTools();

  var delay = 1500;

  const rectX = +rectd3.attr('x');
  const rectY = +rectd3.attr('y');
  const rectWidth = +rectd3.attr('width');
  const rectHeight = +rectd3.attr('height');
  const rectTransform = rectd3.attr('transform');
  const rectCenterX = rectX + rectWidth / 2;

  const sizes = getToolSize();
  const toolSize = sizes.size;
  const toolPadding = sizes.padding;
  const toolSpacing = sizes.spacing;

  let toolXPos = rectCenterX - toolSpacing / 2 - toolSize / 2 - toolPadding;
  const toolYPos = rectY + rectHeight + 2;

  const fullRectWidth = 2 * toolSize + 2 * toolPadding + toolSpacing;
  const fullRectHeight = toolSize + 2 * toolPadding;
  const bgRectX = toolXPos - toolPadding;
  const bgRectY = toolYPos - toolPadding;

  const rectBox = {
    width: fullRectWidth,
    height: fullRectHeight,
    x: bgRectX,
    y: bgRectY,
  };
  const rectExtra = {
    class: 'note-tool',
    transform: rectTransform,
  }
  drawToolBackground(d3.select(rectNode.parentNode), rectBox, rectExtra, "top");

  // delete tool
  d3.select(rectNode.parentNode)
    .append('svg:image')
    .attr('x', toolXPos)
    .attr('y', toolYPos)
    .attr('transform', rectTransform)
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr('xlink:href', getFrontendURL() + "/images/planner_tools/delete.svg")
    .attr('title', ts("p_tool_delete", "Delete"))
    .attr('id', "del-tool")
    .attr('class', "note-tool")
    .style('cursor', 'pointer')
    .on('click', function (e) {
      e.stopImmediatePropagation();
      hideTools();
      deleteNote(id, type);
    })
    .on('mousedown', function (e) {
      e.stopImmediatePropagation();
    })
    .on('mouseup', function (e) {
      e.stopImmediatePropagation();
    })
    .on('mouseout', function (e) {
      if (PlannerGlobals.noteClipBtnTimeout) {
        clearTimeout(PlannerGlobals.noteClipBtnTimeout);
      }
      PlannerGlobals.noteClipBtnTimeout = setTimeout(function () {
        PlannerGlobals.svg.selectAll('.note-tool').remove();
      }, delay);
    })
    .on('mouseenter', function (e) {
      if (PlannerGlobals.noteClipBtnTimeout) {
        clearTimeout(PlannerGlobals.noteClipBtnTimeout);
      }
    });

  toolXPos = rectCenterX + toolSpacing / 2;

  // edit tool
  d3.select(rectNode.parentNode)
    .append('svg:image')
    .attr('x', toolXPos)
    .attr('y', toolYPos)
    .attr('transform', rectTransform)
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr('xlink:href', getFrontendURL() + "/images/planner_tools/modify.svg")
    .attr('title', ts("p_tool_modify", "Modify"))
    .attr('id', "edit-tool")
    .attr('class', "note-tool")
    .style('cursor', 'pointer')
    .on('click', function (e) {
      e.stopImmediatePropagation();
      hideTools();
      if (type === "sole" && _noteCallbacks.onNoteEdit) {
        const note = getNote(id, type);
        if (!note) {
          return;
        }
        _noteCallbacks.onNoteEdit({
          id: note.note_id,
          x: note.x,
          y: note.y,
          text: note.text,
          color: note.color,
        });
        return;
      }
      if (type === "dev" && _noteCallbacks.onNoteEditOnDevice) {
        const dev = getDeviceById(id);
        if (!dev || !dev.noteId) {
          return;
        }
        _noteCallbacks.onNoteEditOnDevice({
          id: dev.noteId,
          deviceId: dev.deviceId,
          text: dev.noteTxt,
          color: dev.noteColor,
        });
        return;
      }
      // TODO: moveplannercode-deadcode — unreachable fallback; onNoteEdit/onNoteEditOnDevice callbacks are always wired (#352)
      openNoteModalPre(id, type);
    })
    .on('mousedown', function (e) {
      e.stopImmediatePropagation();
    })
    .on('mouseup', function (e) {
      e.stopImmediatePropagation();
    })
    .on('mouseout', function (e) {
      if (PlannerGlobals.noteClipBtnTimeout) {
        clearTimeout(PlannerGlobals.noteClipBtnTimeout);
      }
      PlannerGlobals.noteClipBtnTimeout = setTimeout(function () {
        PlannerGlobals.svg.selectAll('.note-tool').remove();
      }, delay);
    })
    .on('mouseenter', function (e) {
      if (PlannerGlobals.noteClipBtnTimeout) {
        clearTimeout(PlannerGlobals.noteClipBtnTimeout);
      }
    });

  d3.select(rectNode.parentNode).on('mouseout', function () {
    if (PlannerGlobals.noteClipBtnTimeout) {
      clearTimeout(PlannerGlobals.noteClipBtnTimeout);
    }
    PlannerGlobals.noteClipBtnTimeout = setTimeout(function () {
      PlannerGlobals.svg.selectAll('.note-tool').remove();
    }, delay);
  });

  createToolTooltip('.note-tool');
}

export function dragNoteStarted(event, d) {
  unHighlight();
  PlannerGlobals.svg.selectAll('.note-tool').remove();

  if (d.nopermissionmsg) {
    toastErrorSingle(d.nopermissionmsg);
  }
  if (d.ghost || PlannerGlobals.mode !== 'basic' || d.nopermission) {
    return;
  }
  PlannerGlobals.panDisable = true;
  PlannerGlobals.isDragging = true;
  PlannerGlobals.hasDraggedNote = false;
  d.dragStartX = d.x;
  d.dragStartY = d.y;
  if (!('lastConfirmedPos' in d)) {
    d.lastConfirmedPos = {x: d.x, y: d.y};
  }
  var cursorXY = getXYP();
  PlannerGlobals.DRAG_HELPER.deviceCursorDiff = {
    x: cursorXY.x - d.x,
    y: cursorXY.y - d.y
  };
  PlannerGlobals.DRAG_HELPER.draggedNote = d;
  PlannerGlobals.DRAG_HELPER.draggedD3This = this;
}

export function dragNote(event, d) {
  if (!d || d.ghost || PlannerGlobals.mode !== 'basic' || d.nopermission) {
    return;
  }
  hideTools();

  disablePlannerButtonsExcept();
  updateDragXY(event);
  var xyCursor = getXYP();
  d.x = xyCursor.x - PlannerGlobals.DRAG_HELPER.deviceCursorDiff.x;
  d.y = xyCursor.y - PlannerGlobals.DRAG_HELPER.deviceCursorDiff.y;
  d.x = uMath.clamp(d.x, -100, 1000);
  d.y = uMath.clamp(d.y, -100, 1000);
  d3.select(PlannerGlobals.DRAG_HELPER.draggedD3This).attr('transform',
      `translate(${d.x},${d.y})`)
  PlannerGlobals.hasDraggedNote = true;
}

export function dragNoteEnd(event, d) {
  PlannerGlobals.svg.selectAll('.note-tool').remove();
  if (d.ghost || PlannerGlobals.mode !== 'basic' || d.nopermission) {
    return;
  }
  enablePlannerButtons();
  PlannerGlobals.panDisable = false;
  PlannerGlobals.isDragging = false;

  highlightNote(d.note_id, "sole");

  startLoading();
  uDevDOM.postItAjax.modifyDrag(d.note_id, d.x, d.y, function () {
    var action = new DragSoleNoteAction(d.note_id,
        {x: d.dragStartX, y: d.dragStartY}, {x: d.x, y: d.y});
    PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
    d.lastConfirmedPos = {x: d.x, y: d.y};
    stopLoading();
  }, function (resp) {
    if ('lastConfirmedPos' in d) {
      d.x = d.lastConfirmedPos.x;
      d.y = d.lastConfirmedPos.y;
    }
    d.nopermission = true;
    redrawNotes();
    toastRemoveAll();
    var returnedErr = genericXHRErrorHandler(resp);
    d.nopermissionmsg = returnedErr;
    stopLoading();
  });

  PlannerGlobals.DRAG_HELPER.draggedNote = null;
  PlannerGlobals.DRAG_HELPER.draggedD3This = null;
}

// TODO: moveplannercode-deadcode — only reached via the dead fallback in showNoteTools' edit handler; note edit now dispatches React callbacks → AddNoteDialog (#352)
export function openNoteModalPre(id, type) {
  var note = getNote(id, type);
  if (!note) {
    return;
  }
  if (type === "dev") {
    var dev = getDeviceById(id);
    if (dev) {
      if (dev.noteNoPermission) {
        if (dev.nopermissionmsg) {
          toastError(dev.nopermissionmsg);
        }
      } else {
        startLoading();
        uDevDOM.postItAjax.modify(note.note_id, dev.noteColor, dev.noteTxt,
            function (resp) {
              stopLoading();
              var fromText = dev.noteTxt;
              var fromColor = dev.noteColor;
              openNoteModal("mod", {
                type: 'device', id: id, callback: function (txt, color) {
                  var action = new ModifyNoteAction(id, fromText, fromColor,
                      txt, color, "dev");
                  PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
                }
              });
            }, function (resp) {
              dev.noteNoPermission = true;
              var returnedErr = genericXHRErrorHandler(resp);
              dev.nopermissionmsg = returnedErr;
              stopLoading();
            });
      }
    }
  } else if (type === "sole") {
    startLoading();
    uDevDOM.postItAjax.modifyDrag(id, note.x, note.y, function () {
      var fromText = note.text;
      var fromColor = note.color;
      openNoteModal("mod", {
        type: "sole", id: id, callback: function (txt, color) {
          modSoleNote(note, color, txt, function () {
            var action = new ModifyNoteAction(id, fromText, fromColor, txt,
                color, "sole");
            PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
          });
        }
      });
      stopLoading();
    }, function (resp) {
      redrawNotes();
      toastRemoveAll();
      var returnedErr = genericXHRErrorHandler(resp);
      note.nopermissionmsg = returnedErr;
      stopLoading();
    });
  }
}

/**
 *
 * @param {Note} note
 */
// TODO: moveplannercode-deadcode — no callers, jQuery note-modal flow superseded by React AddNoteDialog (#352)
export function noteClick(note) {
  if (PlannerGlobals.hasDraggedNote) {
    return;
  }
  openNoteModal("mod", {
    type: "sole", id: note.note_id, callback: function (txt, color) {
      modSoleNote(note, color, txt);
    }
  });
}

export function redrawNotes() {
  if (!PlannerGlobals.notes_on) {
    d3.select('#notes').remove();
  } else {
    var noteElemTry = d3.select("#notes");
    if (!noteElemTry.node()) {
      PlannerGlobals.container.append('g').attr('id', 'notes');
    } else {
      var d = document.getElementById('notes');
      d.parentNode.appendChild(d);
    }

    var contData = d3.select('#notes')
    .selectAll('g')
    .data(PlannerGlobals.notes, function (d) {
      return d.note_id;
    });

    contData.exit().remove();

    contData = contData.enter().append('g')
      .attr('class', 'note-elem note-elem-container')
      .merge(contData);

    contData
    .each(function (d) {
      try {
        var gElem = d3.select(this);
        gElem.html("");
        var fontSize = PlannerGlobals.DEVICE_SIZE / 3;
        var textElem = gElem.append('text')
          .attr('fill', 'black')
          .attr('font-size', fontSize)
          .attr('text-anchor', 'middle')
          .attr('class', 'just-note')
          .style('pointer-events', 'none');

        const splitParts = d.text.split('\n');

        splitParts.map((splittedPart, index) => {
          let dy = 0;
          if (index > 0) {
            dy = '1.2em';
          }
          textElem.append('tspan')
            .attr('x', 0)
            .attr('dy', index === 0 ? dy : fontSize)
            .text(splittedPart);
        })

        var bbox = textElem.node().getBBox();

        gElem.insert('rect', ':first-child')
        .attr('x', bbox.x - 1)
        .attr('y', bbox.y)
        .attr('height', bbox.height)
        .attr('width', bbox.width + 2)
        .attr('rx', bbox.height / 6)
        .attr('ry', bbox.height / 6)
        .attr('fill-opacity', 0.7)
        .attr('fill', d.color ? d.color : 'white')
        .attr('class', 'sole-note-rect just-note')
        .attr('data-noteId', d.note_id)
        .on('mouseenter', function () {
          showNoteTools(d.note_id, "sole");
        });
      } catch (e) {
        console.log('error happened while trying to draw postit', e);
      }
    })
    .on("mousedown", function (event) {
      setPageXY(event);
      setMouseDownXY();
      if (event.which != 1 || ControllerGlobals.currentlyDraggedDevice) {
        event.stopImmediatePropagation();
      }
    })
    .attr('transform', function (d) {
      return `translate(${d.x},${d.y})`
    })
    .call(PlannerGlobals.dragNoteBehavior);
  }
}

export function getNoteRect(id, type) {
  var cls;
  if (type === "dev") {
    cls = ".dev-note-rect";
  } else if (type === "sole") {
    cls = ".sole-note-rect";
  }
  return $(cls + '[data-noteId="' + id + '"]');
}

export function highlightNote(id, type) {
  unHighlight();
  var note = getNote(id, type);
  if (!note || note.ghost) {
    return;
  }
  var noteRect = getNoteRect(id, type);
  noteRect.addClass('note-rect-selected');
  PlannerGlobals.currentlySelectedElement = {
    type: 'note',
    content: {
      text: note.text,
      color: note.color,
      type: type,
      id: id
    }
  };
}

export function toggleNotes() {
  PlannerGlobals.notes_on = !PlannerGlobals.notes_on;
  if (PlannerGlobals.notes_on && PlannerGlobals.symbols_on) {
    PlannerGlobals.symbols_on = false;
    toolbarSwitchSet("symbolname-display", "off");
  }
  toolbarSwitchSet("note-display", PlannerGlobals.notes_on ? "on" : "off");
  redrawDevices();
  redrawNotes();
}

export function setDevNote(devId) {
  const device = getDeviceById(devId);
  if (!device) {
    return;
  }
  if (typeof device.noteTxt === "string" && device.noteTxt.length > 0) {
    if (_noteCallbacks.onNoteEditOnDevice) {
      _noteCallbacks.onNoteEditOnDevice({
        id: device.noteId,
        deviceId: device.deviceId,
        text: device.noteTxt,
        color: device.noteColor,
      });
    }
  } else {
    if (_noteCallbacks.onNoteAddToDevice) {
      _noteCallbacks.onNoteAddToDevice({
        deviceId: device.deviceId,
        floorId: PlannerGlobals.plannerFloorId,
      });
    }
  }
}

export function redrawGhostNote(x, y) {
  var width = PlannerGlobals.DEVICE_SIZE * 2;
  var height = PlannerGlobals.DEVICE_SIZE * 0.45;
  var placeX = x - width / 2;
  var placeY = y - height / 2;
  PlannerGlobals.container.append('rect')
    .attr('id', 'ghostdev')
    .attr('x', placeX)
    .attr('y', placeY)
    .attr('width', width)
    .attr('height', height)
    .attr('fill', 'transparent')
    .attr('fill-opacity', '0')
    .attr('rx', height / 6)
    .attr('ry', height / 6)
    .style('pointer-events', 'none');
}

export function areThereNotes() {
  if (PlannerGlobals.notes.length > 0) {
    return true;
  }
  for (var i = 0; i < PlannerGlobals.devices.length; i++) {
    if (typeof PlannerGlobals.devices[i].noteTxt === "string"
        && PlannerGlobals.devices[i].noteTxt.length > 0) {
      return true;
    }
  }
  return false;
}